<p>
  booking-entry works!
</p>
